import React from 'react'
import styles from './styles.module.css'

const Story = () => {
  return (
    <div className={styles.story_container}>
        <div className={styles.story_heading}>Our Story</div>
        <div>
        Our journey commenced on August 8, 2012, marking the inception of our commitment to excellence in service. The inaugural chapter unfolded at COER University, Roorkee, followed by endeavors with esteemed institutions like Kendriya Vidyalaya Lansdowne and Patanjali Herbal and Food Park in Laksar. Since those early days, our dedication to enhancing both the breadth and caliber of our services has been unwavering. We invite you to connect with us, and we assure you an experience that transcends your expectations. Your satisfaction is not just a goal; it's a commitment we uphold with pride.
        </div>
    </div>
  )
}

export default Story